import { render, staticRenderFns } from "./IbCommissionInTab.vue?vue&type=template&id=30b8f0ec"
import script from "./IbCommissionInTab.vue?vue&type=script&lang=js"
export * from "./IbCommissionInTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports